<dsp-content-card [header]="false">
  <div dsp-content>
    <div class="row">
      <div class="column">
        <div class="dsp-about-header">
          <atlas-icon class="dsp-about-icon" [icon]="'c-info'" [collection]="'user-interface'"
            [size]="'large'"></atlas-icon>

          <h3 class="dsp-about-title">About Investor Portal</h3>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="columns">
        <p>Spicy jalapeno bacon ipsum dolor amet spare ribs pancetta short loin corned beef, turkey pork belly kevin
          porchetta pork chop shank beef. Buffalo leberkas kielbasa salami, turducken rump shankle andouille strip steak
          short loin swine meatloaf filet mignon. Sausage pork belly pig ham hock shank drumstick short ribs biltong
          shankle bacon tongue beef ribs jerky. Landjaeger chuck swine bacon ball tip, cupim cow short loin doner
          porchetta tenderloin t-bone. Ham hock capicola tongue pork chop strip steak corned beef flank. Burgdoggen
          jerky filet mignon hamburger shankle beef ribs short loin t-bone sirloin pork chop brisket landjaeger
          prosciutto tail. Leberkas turkey brisket, meatball swine ball tip jowl landjaeger burgdoggen.</p>
        <div class="dsp-about-minor-title">
          <span>Our Values</span>
        </div>
        <p>Spicy jalapeno bacon ipsum dolor amet spare ribs pancetta short loin corned beef, turkey pork belly kevin
          porchetta pork chop shank beef. Buffalo leberkas kielbasa salami, turducken rump shankle andouille strip steak
          short loin swine meatloaf filet mignon.</p>
      </div>
    </div>
  </div>
</dsp-content-card>